import React from "react";

function Sedan({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41.965"
      height="20.953"
      viewBox="0 0 41.965 20.953"
    >
      <g transform="translate(.325 .325)">
        <path
          d="M123.393 31.154a.426.426 0 01.426-.426h5.2"
          className="cls-1"
          transform="translate(-116.296 -25.053)"
        ></path>
        <path
          d="M144.88 25.471v-6.1h7.526a.71.71 0 01.71.71v5.391"
          className="cls-1"
          transform="translate(-127.046 -19.37)"
        ></path>
        <path
          d="M134.648 25.471V20.08a.711.711 0 01.71-.71h4.4"
          className="cls-1"
          transform="translate(-121.927 -19.37)"
        ></path>
        <path
          d="M141.866 31.154a.425.425 0 01.426-.426h10.22a.425.425 0 01.426.426"
          className="cls-1"
          transform="translate(-125.538 -25.053)"
        ></path>
        <path
          d="M133.173 57.867h-.711a3.2 3.2 0 01-3.013-2.13"
          className="cls-1"
          transform="translate(-119.326 -37.565)"
        ></path>
        <path
          d="M112.4 55.737a3.2 3.2 0 003.014 2.13h.71a3.2 3.2 0 003.013-2.13"
          className="cls-1"
          transform="translate(-110.795 -37.565)"
        ></path>
        <path
          d="M119.332 43.651h-8.919a.71.71 0 01-.674-.486l-.512-1.537a.713.713 0 01-.036-.224v-4.143a.71.71 0 01.71-.71h2.126l2.636-4.613a.711.711 0 01.617-.358h8.62"
          className="cls-1"
          transform="translate(-109.191 -25.479)"
        ></path>
        <path
          d="M121.659 41.527h-6.792"
          className="cls-1"
          transform="translate(-112.031 -30.455)"
        ></path>
        <path
          fill="none"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="0.65"
          d="M5.252 6.81h8.521l-2.414 4.26"
          opacity="0.2"
        ></path>
        <path
          d="M158.711 55.738a3.2 3.2 0 003.013 2.13h.71a3.2 3.2 0 003.013-2.13"
          className="cls-1"
          transform="translate(-133.966 -37.565)"
        ></path>
        <path
          d="M177.486 57.788a3.2 3.2 0 01-3.724-2.051"
          className="cls-1"
          transform="translate(-141.496 -37.565)"
        ></path>
        <path
          d="M15.814 0H0"
          className="cls-1"
          transform="translate(16.859 18.172)"
        ></path>
        <path
          d="M128.877 43.651a.71.71 0 01-.673-.484l-.545-1.622v-4.286a.71.71 0 01.708-.711l2.132-.005 2.635-4.606a.711.711 0 01.617-.357h12.773a1.421 1.421 0 011.156.6l3.12 4.37 8.282.663a.71.71 0 01.66.708v4.581a.71.71 0 01-.393.635l-.878.439a.707.707 0 01-.317.075h-.724"
          className="cls-1"
          transform="translate(-118.43 -25.479)"
        ></path>
        <path
          d="M164.035 37.261h-7.817a.142.142 0 01-.142-.142v-3.977a.143.143 0 01.142-.142h4.589a.993.993 0 01.815.425l2.525 3.612a.142.142 0 01-.112.224z"
          className="cls-1"
          transform="translate(-132.648 -26.19)"
        ></path>
        <path
          d="M181.189 51.116a3.55 3.55 0 10-6.775 0"
          className="cls-1"
          transform="translate(-141.741 -32.944)"
        ></path>
        <circle
          cx="3.195"
          cy="3.195"
          r="3.195"
          className="cls-1"
          transform="translate(32.794 13.912)"
        ></circle>
        <circle
          cx="1.775"
          cy="1.775"
          r="1.775"
          className="cls-3"
          transform="translate(34.214 15.332)"
        ></circle>
        <path
          d="M136.875 51.116a3.551 3.551 0 10-6.775 0"
          className="cls-1"
          transform="translate(-119.57 -32.944)"
        ></path>
        <circle
          cx="3.195"
          cy="3.195"
          r="3.195"
          className="cls-1"
          transform="translate(10.651 13.912)"
        ></circle>
        <circle
          cx="1.775"
          cy="1.775"
          r="1.775"
          className="cls-3"
          transform="translate(12.071 15.332)"
        ></circle>
        <path
          d="M139.276 37.261h6.762a.142.142 0 00.142-.142v-3.976a.142.142 0 00-.142-.142h-5.436a.142.142 0 00-.134.1l-1.329 3.977a.142.142 0 00.137.183z"
          className="cls-1"
          transform="translate(-124.172 -26.19)"
        ></path>
        <rect
          width="2.13"
          height="0.852"
          className="cls-4"
          rx="0.426"
          transform="translate(23.428 11.782)"
        ></rect>
        <rect
          width="1.846"
          height="0.426"
          className="cls-5"
          rx="0.213"
          transform="translate(23.57 11.924)"
        ></rect>
        <rect
          width="2.13"
          height="0.852"
          className="cls-4"
          rx="0.426"
          transform="translate(15.617 11.782)"
        ></rect>
        <rect
          width="1.846"
          height="0.426"
          className="cls-5"
          rx="0.213"
          transform="translate(15.759 11.924)"
        ></rect>
        <path
          d="M0 0h2.13"
          className="cls-4"
          transform="translate(39.185 15.19)"
        ></path>
        <path
          d="M10.651 0H0"
          className="cls-4"
          transform="translate(0 15.332)"
        ></path>
        <path
          d="M189.931 45.079h-1.361a.143.143 0 01-.1-.041l-.426-.426a.142.142 0 01.1-.242h1.787z"
          className="cls-1"
          transform="translate(-148.62 -31.877)"
        ></path>
        <path
          d="M0 0h1.724a.406.406 0 01.406.406A1.014 1.014 0 011.116 1.42H0V0z"
          className="cls-1"
          transform="translate(0 12.492)"
        ></path>
        <path
          d="M.406 0H2.13v1.42H1.014A1.014 1.014 0 010 .406.406.406 0 01.406 0z"
          className="cls-1"
          transform="translate(7.101 12.492)"
        ></path>
        <path
          d="M128.286 45.789h-.622v-1.42h1.19a.142.142 0 01.127.205l-.568 1.136a.142.142 0 01-.127.079z"
          className="cls-1"
          transform="translate(-118.433 -31.877)"
        ></path>
        <path
          fill="none"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="0.284"
          d="M15.703 0v1.7h-.011l-.071.071-.071-.071h-.03l-.071.071-.071-.071h-.03l-.071.071-.071-.071h-.03l-.071.071-.071-.071h-.03l-.071.071-.071-.071h-.01V0z"
          style={{ isolation: "isolate" }}
          opacity="0.5"
        ></path>
        <path
          d="M0 0v10.935"
          className="cls-5"
          transform="translate(22.703 6.882)"
        ></path>
      </g>
    </svg>
  );
}

export default Sedan;
